<template>
<div class="chapter">
<div class="inner_page">
<h1 class="P_Heading_1" id="auto_bookmark_toc_1"><span>Shifting Views</span></h1>
<p class="P_Normal"> </p>
<p class="P_Norm-NoIndent">By Meg Harding</p>
<p class="P_Norm-NoIndent"> </p>
<p class="P_Norm-NoIndent">A Carlisles novel</p>
<p class="P_Normal"> </p>
<p class="P_Normal">Successful fashion model Denver Carlisle is finally living on his own. He’s got a new apartment, a neighbor who has a problem shutting his blinds, and a local bakery with an owner who makes his knees weak. It’s raining men, and Denver hasn’t gotten any in a long time. Going out on a limb, he asks Ethan Monahan out and resorts to a little exhibitionism for his neighbor. Only to be turned down by both. That’s a first.</p>
<p class="P_Normal">Ethan Monahan runs his own bakery and has a new neighbor who walks around naked. The latter is a little too distracting. When his naked neighbor turns out to be none other than model Denver Carlisle—and the customer who asked him out—Ethan tries to make amends. In a purely friendly way.</p>
<p class="P_Normal">Friendship leads to more, and both men find themselves in over their heads with emotions and compromises. Denver has trust issues that could span the Sahara, and Ethan is a product of the foster system with a chip on his shoulder and a serious wariness of those with money. There’s only one way to reconcile their issues: work together.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0001.vue?2a508709